import React from 'react';
import HostUsersPage from './HostUsersPage';

/** Host Students page — GET /v1/host/booking-clients/students */
export default function HostStudentsPage() {
  return <HostUsersPage variant="students" />;
}
